import { Blockchain } from "@rarible/api-client"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

const blockchainTestKekViem = {
  id: 6231991,
  name: "BLOCK CHAIN",
  nativeCurrency: {
    decimals: 18,
    name: "Bitcoin",
    symbol: "BITCOIN",
  },
  rpcUrls: {
    default: { http: ["https://block-chain-testkek.alt.technology"] },
  },
}

export const blockchainTestKekConfig: StaticEthereumBlockchainConfig = {
  name: "BLOCK CHAIN",
  icon: "/images/blockchains/blockchainkek.svg",
  isEvm: true,
  testnet: true,
  isTestnet: true,
  baseFee: 200,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://blockchainkek-api.rarible.org",
  chainId: 6231991,
  blockchain: Blockchain.BLOCKCHAINKEK,
  chainName: "BLOCK CHAIN",
  exchange: {
    v2: "0x2c46e116a742C159fa79e2717b50759EC979e3Be",
    wrapper: "0xC49dB032fB73eacf337C27831A1435BBDCF2B044",
  },
  blockExplorers: [
    {
      url: "https://explorer.block-chain.lol/",
      icon: "/images/scanner.svg",
      adress: "https://explorer.block-chain.lol/address/${adrress}",
    },
  ],
  rpcUrls: [
    { url: "https://block-chain-testkek.alt.technology", isPublic: true },
  ],
  privateRpcNodeSlug: "blockchainkek-node",
  transferProxies: {
    nft: "0x892f0e3DEaC041b12b748bf9d7D1BA480d266696",
    erc721Lazy: "0x147d06FbDA085C0455615E554D87262B0726ad0c",
    erc20: "0x12181eDedD1f81838580668bb5B50e1030df4667",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId(
      "BLOCKCHAINKEK:0x0000000000000000000000000000000000000000",
    ),
    symbol: "BITCOIN",
    name: "Bitcoin",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId(
      "BLOCKCHAINKEK:0x12b0146068e8bc3935639e847b06c64737b34c7e",
    ),
    symbol: "WBITCOIN",
    name: "Wrapped Bitcoin",
    decimals: 18,
  },
  addFundsLink: "https://bridge.block-chain.lol/",
  hasStabilityProtocol: true,
  viem: blockchainTestKekViem,
}

export const getBlockchainTestKekConfig = (): StaticEthereumBlockchainConfig =>
  blockchainTestKekConfig
